import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: () => import('@/views/Home')
    },
    {
      path: '/qr-scan/:organization_id/:digi_board_id',
      name: 'QrScanHome',
      component: () => import('@/views/qrscan/LandingPage')
    },
    {
      path: '/check-in',
      name: 'Checkin',
      component: () => import('@/views/process/Checkin/CheckinIndex')
    },
    {
      path: '/check-out',
      name: 'Checkout',
      component: () => import('@/views/process/Checkout/CheckoutIndex')
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('@/views/process/Register/RegisterIndex')
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('@/components/About')
    },
    {
      path: '/*',
      name: 'Not Found',
      component: () => import('@/views/app/404.vue')
    }
  ]
})

export default router
